/**
 * Financial records (spec sections 13, 23, 39).
 *
 * A DailyRecord is one settled game-day of profit & loss. The rolling history
 * powers the finance dashboard and metrics (kept to the last N days).
 */
export interface DailyRecord {
  year: number;
  month: number;
  day: number;
  revenue: number;
  expense: number;
  profit: number;
  cash: number; // cash on hand at settlement
  vehiclesServed: number; // during that day
  vehiclesRejected: number; // during that day
}

export interface FinanceState {
  /** Parking revenue accrued so far during the current (unsettled) day. */
  todayRevenue: number;
  /** Rolling history of settled days (most recent last). */
  history: DailyRecord[];
  /** Lifetime served/rejected totals captured at the last settlement, so the
   *  per-day deltas can be computed. */
  lastServedTotal: number;
  lastRejectedTotal: number;
}

/** How many days of daily history to retain (spec section 39: >= 30). */
export const HISTORY_DAYS = 30;

export function createFinanceState(): FinanceState {
  return {
    todayRevenue: 0,
    history: [],
    lastServedTotal: 0,
    lastRejectedTotal: 0,
  };
}
